/**
 * SunnaFoods — guarantee the cart-drawer CHECKOUT button always navigates.
 *
 * The drawer checkout button is a native <button type="submit" form="cart-form">,
 * but that form lives inside a modal <dialog>, and submit-to-navigate from inside
 * a modal dialog can intermittently fail to navigate. Shopify's cart is stored
 * server-side, so going straight to /checkout always reflects the current cart.
 *
 * Delegated + capture-phase on document, so it survives every drawer re-render
 * (section morphs on qty change / add) and never goes stale.
 * Scoped to .cart-drawer so the /cart page keeps 100% native behaviour.
 */
(function () {
  if (window.__sfCheckoutNav) return;
  window.__sfCheckoutNav = true;

  function checkoutUrl() {
    var root = '/';
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) root = Shopify.routes.root;
    } catch (e) {}
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'checkout';
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var btn = target.closest('#checkout, .cart__checkout-button');
      if (!btn) return;

      // Only take over inside the cart drawer; leave the /cart page native.
      if (!btn.closest('.cart-drawer')) return;

      // Respect the disabled (empty cart) state.
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      event.preventDefault();
      window.location.href = checkoutUrl();
    },
    true
  );
})();

/*
 * NOTE (2026-09-14): the old "cart plan switch" block (3-Month <-> 6-Month plan by bottle
 * count, with its own gift add/remove logic) was removed. The Black Seed offer is now the
 * bundle picker in snippets/sf-subscribe-widget.liquid, and every cart-line rule (gift lines
 * for 2+ bottle bundles, subscription plan) lives in snippets/sf-cart-rules.liquid and
 * sf-cart-page-rules.liquid. That block wrapped window.fetch and deleted every line tagged
 * `_sf_gift`, which fought the new rules in a loop and froze the product page.
 */

/**
 * SunnaFoods — Fit Check quiz: preselect the 6-Month Supply.
 *
 * The product page keeps its normal default (3-Month Supply).
 * Only when the URL carries ?plan=6m (the link the quiz uses) does this
 * script tick the 6-Month option, exactly as if the visitor tapped it.
 */
(function () {
  try {
    if (window.__sfQuizPlan) return;
    window.__sfQuizPlan = true;

    var params = new URLSearchParams(window.location.search);
    var wantSix = params.get('plan') === '6m' || params.get('selling_plan') === '692960199004';
    if (!wantSix) return;

    var tries = 0;
    function pick() {
      var radio = document.querySelector('input.sf-sub__radio[value="plan6"]');
      if (radio) {
        if (!radio.checked) {
          radio.click();
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      if (++tries < 40) setTimeout(pick, 150);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pick);
    } else {
      pick();
    }
  } catch (e) {
    /* never break the page */
  }
})();
